import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

@Component({
  selector: 'ui-chip[ui-chip-input], ui-chip[ui-chip-info]',
  templateUrl: './chip.component.html',
  styleUrls: ['./chip.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class UIChipComponent {
  readonly deletable = input<boolean>(false);
  readonly deleteEvent = output<void>();
}
